import { summarizeDayLog, type SummarizableDayLog } from '@proerp/shared';

/**
 * Was der Bauherr gleich unterschreibt — im Klartext, bevor er den Stift
 * ansetzt (ADR 0074, ergänzt 2026-08-10).
 *
 * Vorher bekam er ein leeres Feld gereicht und zeichnete blind gegen. Eine so
 * geleistete Unterschrift ist im Streitfall angreifbar und fachlich eine
 * Zumutung — der Tagesbericht ist ein **Beweisdokument**, keine Quittung.
 *
 * Leere Aussage-Zeilen bleiben stehen und heißen „keine": Dass an diesem Tag
 * nichts behindert hat, ist der Inhalt, den er bestätigt — nicht eine fehlende
 * Angabe. Sie werden grau gesetzt, damit man sie von einer echten Eintragung
 * unterscheidet, aber sie verschwinden nicht.
 */
export function DaySignatureSummary({
  day,
  dayLabel,
  taskTitle,
}: {
  day: SummarizableDayLog;
  dayLabel: string;
  taskTitle: string;
}) {
  const rows = summarizeDayLog(day);

  return (
    <section
      aria-label="Das wird unterschrieben"
      className="rounded-xl border border-border bg-muted/30 p-3"
    >
      <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
        Das wird unterschrieben
      </p>
      <p className="mt-1 text-sm font-medium text-foreground">{taskTitle}</p>
      <p className="text-sm text-muted-foreground">{dayLabel}</p>

      <dl className="mt-3 flex flex-col gap-2 border-t border-border pt-3">
        {rows.map((row) => (
          <div key={row.label} className="flex flex-col gap-0.5">
            <dt className="text-xs text-muted-foreground">{row.label}</dt>
            <dd
              className={
                row.isEmpty
                  ? 'text-sm italic text-muted-foreground'
                  : 'whitespace-pre-line text-sm text-foreground'
              }
            >
              {row.value}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
